/* Garmin Connect: dark chrome, as the profile dialog and the plan cards. */
.connection {
  margin: var(--space-5) 0;
}

.heading {
  margin: 0 0 var(--space-2);
  color: #a7adb4;
  font-size: var(--text-sm);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.appRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-3) 0;
  border-bottom: 1px solid rgb(255 255 255 / 10%);
}

.appName {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-1) var(--space-3);
  font-weight: 600;
}

.state {
  color: #a7adb4;
  font-size: var(--text-sm);
  font-weight: 400;
}

.stateOn {
  color: var(--color-success);
}

.button {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  border: 1px solid rgb(255 255 255 / 16%);
  border-radius: var(--radius-sm);
  background: transparent;
  color: #fff;
  font: inherit;
  cursor: pointer;
}

.button:hover:not(:disabled) {
  background: rgb(255 255 255 / 6%);
}

.button:disabled {
  opacity: 0.6;
  cursor: progress;
}

.primary {
  composes: button;
  border-color: var(--color-accent);
  background: var(--color-accent);
  color: var(--color-on-accent);
  font-weight: 600;
}

.primary:hover:not(:disabled) {
  background: var(--color-accent-hover);
}

.note,
.success,
.error {
  margin: var(--space-2) 0 0;
  font-size: var(--text-sm);
}

.note {
  color: #a7adb4;
}

.success {
  color: var(--color-success);
}

/* "View it on Strava": the message's own colour, not the browser's blue. */
.success a {
  color: inherit;
  font-weight: 600;
}

.error {
  color: var(--color-danger);
}

.send {
  padding: 0 var(--space-4) var(--space-4);
}

/* /garmin/callback */
.callbackPage {
  display: grid;
  height: 100%;
  padding: var(--space-4);
  place-items: center;
  background: var(--color-bg);
}

.callbackCard {
  display: grid;
  gap: var(--space-4);
  justify-items: center;
  width: min(420px, 100%);
  padding: var(--space-6, 32px) var(--space-5);
  border: 1px solid rgb(255 255 255 / 10%);
  border-radius: var(--radius-md);
  background: #1e2329;
  color: #fff;
  text-align: center;
}

.callbackCard h1 {
  margin: 0;
  font-size: var(--text-lg);
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgb(255 255 255 / 15%);
  border-top-color: var(--color-accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 2.4s;
  }
}
